import React, { Component } from 'react';
import { Grid, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { FeatureImage } from './FeatureImage';
import { OtherFeatures } from './OtherFeatures';
import { loading } from '../../store/actions/uploads';

class FeatureClass extends Component {
  componentDidMount() {
    const {
      setTemplateKey,
      match: {
        params: { id }
      }
    } = this.props;
    setTemplateKey(id);
    window.scroll(0, 0);
  }

  componentDidUpdate() {
    const {
      templateKey,
      setTemplateKey,
      match: {
        params: { id }
      }
    } = this.props;
    if (templateKey !== id) {
      setTemplateKey(id);
      window.scroll(0, 0);
    }
  }

  render() {
    return (
      <Grid>
        <Row>
          <FeatureImage />
        </Row>
        <Row>
          <OtherFeatures />
        </Row>
      </Grid>
    );
  }
}

const mapStateToProps = state => ({
  templateKey: state.uploads.template_key
});

const mapDispatchToProps = dispatch => {
  return {
    setTemplateKey: id => {
      dispatch(loading(id));
    }
  };
};

const Feature = connect(
  mapStateToProps,
  mapDispatchToProps
)(FeatureClass);

export default Feature;



// WEBPACK FOOTER //
// ./src/comps/Feature/Feature.js